export default "https://jx8d14icr6.execute-api.us-west-2.amazonaws.com";